/* tslint:disable */
/* eslint-disable */
/**
 * K1 OpenAPI
 * API fuer die Nutzung der K1 REST-Schnittstelle
 *
 * The version of the OpenAPI document: 1.168.0-SNAPSHOT
 * Contact: diplan-backend@init.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorRest } from '../models';
// @ts-ignore
import type { NutzerVerfahrenRest } from '../models';
/**
 * XPlanverfahrenImportResourceApi - axios parameter creator
 * @export
 */
export const XPlanverfahrenImportResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt können Verfahren gemäß dem Standard XPlanverfahren importiert werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Importieren von Verfahren.
         * @param {File} xplanverfahrenImport Datei mit Verfahren
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadXPlanverfahren: async (xplanverfahrenImport: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xplanverfahrenImport' is not null or undefined
            assertParamExists('uploadXPlanverfahren', 'xplanverfahrenImport', xplanverfahrenImport)
            const localVarPath = `/xplanverfahren/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (xplanverfahrenImport !== undefined) { 
                localVarFormParams.append('xplanverfahrenImport', xplanverfahrenImport as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XPlanverfahrenImportResourceApi - functional programming interface
 * @export
 */
export const XPlanverfahrenImportResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XPlanverfahrenImportResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt können Verfahren gemäß dem Standard XPlanverfahren importiert werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Importieren von Verfahren.
         * @param {File} xplanverfahrenImport Datei mit Verfahren
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadXPlanverfahren(xplanverfahrenImport: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NutzerVerfahrenRest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadXPlanverfahren(xplanverfahrenImport, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XPlanverfahrenImportResourceApi.uploadXPlanverfahren']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * XPlanverfahrenImportResourceApi - factory interface
 * @export
 */
export const XPlanverfahrenImportResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XPlanverfahrenImportResourceApiFp(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt können Verfahren gemäß dem Standard XPlanverfahren importiert werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt zum Importieren von Verfahren.
         * @param {File} xplanverfahrenImport Datei mit Verfahren
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadXPlanverfahren(xplanverfahrenImport: File, options?: RawAxiosRequestConfig): AxiosPromise<Array<NutzerVerfahrenRest>> {
            return localVarFp.uploadXPlanverfahren(xplanverfahrenImport, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XPlanverfahrenImportResourceApi - object-oriented interface
 * @export
 * @class XPlanverfahrenImportResourceApi
 * @extends {BaseAPI}
 */
export class XPlanverfahrenImportResourceApi extends BaseAPI {
    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt können Verfahren gemäß dem Standard XPlanverfahren importiert werden.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
     * @summary Endpunkt zum Importieren von Verfahren.
     * @param {File} xplanverfahrenImport Datei mit Verfahren
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XPlanverfahrenImportResourceApi
     */
    public uploadXPlanverfahren(xplanverfahrenImport: File, options?: RawAxiosRequestConfig) {
        return XPlanverfahrenImportResourceApiFp(this.configuration).uploadXPlanverfahren(xplanverfahrenImport, options).then((request) => request(this.axios, this.basePath));
    }
}

